var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('ContactForm',{staticClass:"contactPopup",class:[_vm.popUp ? 'showPopup' : ''],on:{"closePopUp":_vm.changePopUp}}),_c('HeaderDiv',{on:{"openPopUp":_vm.changePopUp}}),_c('Home',{on:{"openPopUp":_vm.changePopUp}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }